var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.158h6.89v13.148a6.73 6.73 0 0 1-.553.905c-.35.482-.737.875-1.111 1.096-1.221.722-3.177 1.752-4.01 2.18l1.444 2.809c.841-.433 2.866-1.499 4.172-2.27.89-.525 1.578-1.293 2.06-1.959.49-.675.845-1.35 1.036-1.811l.12-.29V2H7v3.158zm13.996-2.584v16.312c-.073.988-.624 3.323-2.122 4.821-1.714 1.714-4.06 3-4.976 3.404l1.276 2.89c1.141-.504 3.858-1.984 5.933-4.06 2.27-2.27 2.959-5.522 3.044-6.905l.004-.049V2.574h-3.158z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuv);
export default __webpack_public_path__ + "static/media/JUV.955009aa1480324249a1b41ef66f855a.svg";
export { ForwardRef as ReactComponent };